
import { Component, Prop, Vue } from "vue-property-decorator";
import vuexStore from "@/store/vuex-store";
import {
  Template,
  ExamMsgTemp
} from "@/lib/model/exambuilder/exam-component/message-template";
import Pop from "@/views/ai-builder/components/blue-pop.vue";

@Component({ components: { Pop } })
export default class SelectTemp extends Vue {
  @Prop({}) exam!: any;
  @Prop({}) onlyShow!: boolean;
  @Prop({}) examId!: number;
  @Prop({}) examName!: string;
  title = "设置消息模板";
  template = new Template();
  examTemp = new ExamMsgTemp();
  TLList: Template[] = [
    new Template(),
    new Template(),
    new Template(),
    new Template(),
    new Template(),
    new Template(),
    new Template(),
    new Template(),
    new Template(),
    new Template()
  ];
  phoneTempList: Template[] = [new Template()];
  emailTempList: Template[] = [new Template()];
  content = "";
  rules = {
    name: [{ required: true, message: "请输入字段名称", trigger: "change" }]
  };
  noticeMessageHourLimitList = [
    { label: "邀请后24h未作答的候选人", value: 24 },
    { label: "邀请后48h未作答的候选人", value: 48 }
  ];
  showTipOfMessage = false;

  async created() {
    this.examTemp = new ExamMsgTemp();
    // 3场景 x 2方式 六种模板
    this.TLList[0].env = 1;
    this.TLList[0].type = 1;
    this.TLList[1].env = 1;
    this.TLList[1].type = 2;
    this.TLList[2].env = 2;
    this.TLList[2].type = 1;
    this.TLList[3].env = 2;
    this.TLList[3].type = 2;
    this.TLList[4].env = 3;
    this.TLList[4].type = 1;
    this.TLList[5].env = 3;
    this.TLList[5].type = 2;
    this.TLList[6].env = 4;
    this.TLList[6].type = 1;
    this.TLList[7].env = 4;
    this.TLList[7].type = 2;
    this.TLList[8].env = 5;
    this.TLList[8].type = 1;
    this.TLList[9].env = 5;
    this.TLList[9].type = 2;
    this.examTemp.templateList = this.TLList;

    await this.getTempList();

    if (this.examId) {
      ExamMsgTemp.get(this.examId).then(res => {
        if (res.code === 0) {
          this.examTemp = new ExamMsgTemp().assign(res.data);
          this.TLList = this.examTemp.templateList;
        }
      });
    }
  }

  mounted() {
    this.showTipOfMessage = vuexStore.companyPower.enableMessageNotice != 1;
  }

  // 跳转管理模版
  jumpMessageTemp(env = 0, tem = 1) {
    const { origin, search } = window.location;
    window.open(
      origin + "/messageTemp/list" + search + `&env=${env}&tem=${tem}`
    );
  }

  isRotate = true;
  targetRotage = 0;

  async refresh(num = 0) {
    if (this.isRotate) {
      this.isRotate = false;
      this.targetRotage = num;
      await this.getTempList();
      this.$message.success("刷新成功");
      const time = setTimeout(() => {
        this.isRotate = true;
        clearTimeout(time);
      }, 1000);
    } else {
      // this.$message.warning("太频繁啦");
      return;
    }
  }

  // 所有短信 邮件 模板list
  async getTempList() {
    const p1 = Template.getTemplateList({
      type: 1,
      auditStatusList: [1],
      returnAll: true
    }).then(res => {
      this.phoneTempList = res.data.data.list;
    });
    const p2 = Template.getTemplateList({
      type: 2,
      auditStatusList: [1],
      returnAll: true
    }).then(res => {
      this.emailTempList = res.data.data.list;
    });
    await Promise.all([p1, p2]).then(res => {
      return true;
    });
  }

  // 场景筛选
  phoneTempListEnv(env: number) {
    return this.phoneTempList.filter(res => res.env === env);
  }

  emailTempListEnv(env: number) {
    return this.emailTempList.filter(res => res.env === env);
  }

  getTextFromId(id: number, type = "phone") {
    if (type === "phone") {
      return (
        this.phoneTempList.find(t => {
          return t.templateId === id;
        }) || new Template()
      );
    } else {
      return (
        this.emailTempList.find(t => {
          return t.templateId === id;
        }) || new Template()
      );
    }
  }

  ok() {
    if (this.examId) {
      this.examTemp.templateList = this.TLList;
      this.examTemp.examId = this.examId;
      ExamMsgTemp.set(this.examTemp).then(res => {
        if (res.code === 0) {
          this.$emit("ok");
        }
      });
    }
  }

  //关闭
  close() {
    this.$emit("cancel", false);
  }
}
